module.exports = __webpack_public_path__ + "static/banner-person-5996d16a7599a653ee5fc62af307e8ca.png";